export default "/images/c1cfd69a9eea35ac6a8a3da03ada5107.avif";